
import React from "react";
import { BookingFormData } from "../ParcelBookingForm";
import { Loader2 } from "lucide-react";
import BookingFormSummary from "./confirmation/BookingFormSummary";
import TermsDialog from "./confirmation/TermsDialog";
import PostBookingModal from "../bookings/PostBookingModal";
import { useState } from "react";

interface ConfirmationStepProps {
  formData: BookingFormData;
  onConfirm: () => void;
  showTerms: boolean;
  setShowTerms: (show: boolean) => void;
  isSubmitting?: boolean;
  isBookingComplete?: boolean;
  onNavigateToBookings?: () => void;
}

const ConfirmationStep = ({ formData, onConfirm, showTerms, setShowTerms, isSubmitting = false, isBookingComplete = false, onNavigateToBookings }: ConfirmationStepProps) => {
  const [showInfoGraphic, setShowInfoGraphic] = useState(false);

  const handleConfirm = async () => {
    onConfirm();
  };

  // Show infographic when booking is complete
  React.useEffect(() => {
    if (isBookingComplete) {
      setShowInfoGraphic(true);
    }
  }, [isBookingComplete]);

  const handleModalClose = () => {
    setShowInfoGraphic(false);
    if (onNavigateToBookings) {
      onNavigateToBookings();
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold mb-4 text-card-foreground">Booking Summary</h2>
        <BookingFormSummary formData={formData} />
      </div>

      {isSubmitting && (
        <div className="flex justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <span className="ml-2 text-foreground">Saving your booking...</span>
        </div>
      )}

      <TermsDialog 
        showTerms={showTerms}
        setShowTerms={setShowTerms}
        isSubmitting={isSubmitting}
        onConfirm={handleConfirm}
      />

      {/* Post Booking Info Modal */}
      <PostBookingModal 
        isOpen={showInfoGraphic}
        onClose={handleModalClose}
      />
    </div>
  );
};

export default ConfirmationStep;
